/**
 *
 * SurveysImport
 *
 */

import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"
import { Modal, Button, Progress } from "antd"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"
import { get, pick } from "lodash"
import reducer from "./reducer"
import saga from "./saga"
import { Empty } from "./Empty"
import check from "../../images/check.svg"
import {
  makeSelectIsDownloading,
  makeSelectIsUploading,
  makeSelectSummaryData,
  makeSelectSummaryHas,
  makeSelectPercentage,
  makeSelectIsData,
  makeSelectIsLoading,
  makeSelectSurveyData,
} from "./selectors"

import {
  getTemplateSurvey,
  uploadTemplate,
  uploadTemplateFailed,
  saveTemplateSurveyWatcher,
  getSurveySummary,
} from "./actions"
import SummaryScreenV3 from "../../components/SummaryScreenV3"

/* eslint-disable react/prefer-stateless-function */
export class SurveysImport extends React.Component {
  state = {
    loadScreen: "",
    modalProgress: false,
  }

  componentDidMount = () => {
    const { match } = this.props
    this.props.getSurveySummary(match.params.id)
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.isData !== prevState.isData) {
      return { isData: nextProps.isData } // <- this is setState equivalent
    }
    return null
  }

  urlBack = () => {
    this.props.uploadTemplateFailed(false)
    const url = `/models/surveys/${this.props.match.params.id}`
    this.props.history.push(url)
  }

  setChangeModal = (name, value) => {
    this.setState({ [name]: value })
  }

  renderModalProgress = () => {
    return (
      <Modal
        visible={this.state.modalProgress}
        okText="Aceptar"
        closable={false}
        footer={
          this.props.percentage !== 100
            ? null
            : [
                <Button
                  key="submit"
                  type="primary"
                  onClick={() => {
                    this.setChangeModal("modalProgress", false)
                    this.props.history.push(this.urlBack())
                  }}>
                  Aceptar
                </Button>,
              ]
        }
        width={520}>
        {this.props.percentage !== 100 ? (
          <div className="modalSuccess">
            <Progress
              style={{ margin: "0 auto" }}
              width={80}
              type="circle"
              percent={this.props.percentage}
            />
            <span
              style={{
                justifySelf: "center",
                alignSelf: "center",
                marginTop: "1em",
                fontSize: "14px",
                color: "#555151",
              }}>
              {" "}
              La importación puede tardar unos minutos...
            </span>
          </div>
        ) : (
          <div className="modalSuccess" style={{ textAlign: "center" }}>
            <img src={check} />
            <span style={{ marginTop: 14, fontWeight: 600, color: "#555151" }}>
              {this.state.loadScreen
                ? "La importación de cuestionarios ha sido completada con éxito."
                : "La importación ha sido completada con éxito."}
            </span>
            <span
              style={{
                justifySelf: "center",
                alignSelf: "center",
                marginTop: "1em",
                fontSize: "14px",
                color: "#555151",
              }}>
              {" "}
              Ahora podrás visualizar las preguntas en la sección cuestionarios.
            </span>
          </div>
        )}
      </Modal>
    )
  }

  renderEmpty = () => {
    const {
      isData,
      history,
      isDownloading,
      getTemplate,
      match,
      uploadTemplate,
      isUploading,
      surveyData,
    } = this.props
    return (
      <Empty
        isData={isData}
        history={history}
        isDownloading={isDownloading}
        getTemplate={getTemplate}
        match={match}
        uploadTemplate={uploadTemplate}
        isUploading={isUploading}
        surveyData={surveyData}
      />
    )
  }

  renderContent = () => {
    const {
      summaryHas,
      match,
      uploadTemplate,
      summaryData,
      saveTemplateSurveyWatcher,
      history,
    } = this.props
    if (!summaryHas) {
      return this.renderEmpty()
    }
    return (
      <SummaryScreenV3
        backModalTitle="¿Estás seguro de que deseas salir de la importación?"
        content={["dimension", "subdimension", "pregunta", "error"]}
        gridHeader="171px 138px 292px 1.5fr"
        gridContent="171px 138px 292px 1.5fr"
        header={["Dimensión", "Subdimensión", "Pregunta", "Error"]}
        hasUpdates={false}
        history={history}
        id={match.params.id}
        maxWidthTable="85%"
        onFinalize={(params) => {
          params = {
            params,
            id_survey: summaryData.id_survey,
            timestamp: summaryData.timestamp,
          }
          this.setChangeModal("modalProgress", true)
          saveTemplateSurveyWatcher(params)
        }}
        typeImport="Importación"
        textResumeQuestion={{
          text: "pregunta",
          success: (
            <React.Fragment>
              <span>{`${get(summaryData, "count_import_question", 0)} `}</span>
              {`${plural(
                "pregunta",
                get(summaryData, "count_import_question", 0),
                "s"
              )} ${plural(
                "importada",
                get(summaryData, "count_import_question", 0),
                "s"
              )}`}
            </React.Fragment>
          ),
          failed: (
            <React.Fragment>
              <span>{`${get(summaryData, "count_error_question", 0)} `}</span>
              {`${plural(
                "pregunta",
                get(summaryData, "count_error_question", 0),
                "s"
              )} sin importar`}
            </React.Fragment>
          ),
        }}
        textResumeDimension={{
          text: "dimension",
          success: (
            <React.Fragment>
              <span>{`${get(summaryData, "count_import_dimension", 0)} `}</span>
              {`${plural(
                "dimension",
                get(summaryData, "count_import_dimension", 0),
                "es"
              )} ${plural(
                "importada",
                get(summaryData, "count_import_dimension", 0),
                "s"
              )}`}
            </React.Fragment>
          ),
          failed: (
            <React.Fragment>
              <span>{`${get(summaryData, "count_error_dimension", 0)} `}</span>
              {`${plural(
                "dimension",
                get(summaryData, "count_error_dimension", 0),
                "es"
              )} sin importar`}
            </React.Fragment>
          ),
        }}
        textResumeSubDimension={{
          text: "subdimension",
          success: (
            <React.Fragment>
              <span>{`${get(
                summaryData,
                "count_import_subdimension",
                0
              )} `}</span>
              {`${plural(
                "subdimension",
                get(summaryData, "count_import_subdimension", 0),
                "es"
              )} ${plural(
                "importada",
                get(summaryData, "count_import_subdimension", 0),
                "s"
              )}`}
            </React.Fragment>
          ),
          failed: (
            <React.Fragment>
              <span>{`${get(
                summaryData,
                "count_error_subdimension",
                0
              )} `}</span>
              {`${plural(
                "subdimension",
                get(summaryData, "count_error_subdimension", 0),
                "es"
              )} sin importar`}
            </React.Fragment>
          ),
        }}
        title="Cuestionario"
        uploadWithId
        uploadTemplate={uploadTemplate}
        urlBackH
        urlBackF={this.urlBack}
        {...pick(summaryData, ["count_import", "count_error", "list_errors"])}
      />
    )
  }

  render() {
    return (
      <React.Fragment>
        {this.renderContent()}
        {this.renderModalProgress()}
      </React.Fragment>
    )
  }
}

SurveysImport.propTypes = {
  isData: PropTypes.bool,
  isLoading: PropTypes.bool,
  getTemplate: PropTypes.func,
}

const mapStateToProps = createStructuredSelector({
  isDownloading: makeSelectIsDownloading(),
  isUploading: makeSelectIsUploading(),
  summaryData: makeSelectSummaryData(),
  summaryHas: makeSelectSummaryHas(),
  percentage: makeSelectPercentage(),
  isData: makeSelectIsData(),
  isLoading: makeSelectIsLoading(),
  surveyData: makeSelectSurveyData(),
})

function mapDispatchToProps(dispatch) {
  return {
    getSurveySummary: (params) => dispatch(getSurveySummary(params)),
    getTemplate: (params) => dispatch(getTemplateSurvey(params)),
    uploadTemplate: (params) => dispatch(uploadTemplate(params)),
    uploadTemplateFailed: (params) => dispatch(uploadTemplateFailed(params)),
    saveTemplateSurveyWatcher: (params) =>
      dispatch(saveTemplateSurveyWatcher(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({ key: "surveysImport", reducer })
const withSaga = injectSaga({ key: "surveysImport", saga })

export default compose(withConnect, withReducer, withSaga)(SurveysImport)
